import { ChatScreen } from '../shared/ChatScreen';

interface PhysicianAssistantChatScreenProps {
  onBack?: () => void;
}

export function PhysicianAssistantChatScreen({ onBack }: PhysicianAssistantChatScreenProps) {
  return <ChatScreen onBack={onBack} userRole="physician_assistant"  chatUser={null}/>;
}
